
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { bool_type, option_type, class_type, string_type, int32_type, union_type, list_type, record_type, float64_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { SpatialDistance, Provider, SpatialDistance_$reflection, Provider_$reflection, SpatialDistanceModule_inKilometers, Point, Point_$reflection } from "./Forecast.js";
import { min, map as map_1, max, toList, sumBy, head, singleton, append, pairwise, filter, length } from "../fable_modules/fable-library-js.5.0.0/Seq.js";
import { tryFind, ofArray, singleton as singleton_1, map, toArray } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { map as map_2, item } from "../fable_modules/fable-library-js.5.0.0/Array.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0/Range.js";
import { Exception, equals, comparePrimitives } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { WeatherTypeModule_Parameter, WeatherTypeModule_Parameter_$reflection } from "./Weather.js";
import { compare as compare_1, printf, toFail } from "../fable_modules/fable-library-js.5.0.0/String.js";
import { op_Addition, op_Subtraction } from "../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { fromMinutes, fromDays, fromHours, ticks, totalSeconds, fromSeconds } from "../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { toFloat64 } from "../fable_modules/fable-library-js.5.0.0/BigInt.js";
import { compare } from "../fable_modules/fable-library-js.5.0.0/Date.js";
import { polygonPoints } from "./Snow1gModelArea.js";
import { defaultArgWith } from "../fable_modules/fable-library-js.5.0.0/Option.js";

export class Rectangle extends Record {
    constructor(North, East, South, West) {
        super();
        this.North = North;
        this.East = East;
        this.South = South;
        this.West = West;
    }
}

export function Rectangle_$reflection() {
    return record_type("StenaWeather.Domain.Models.Rectangle", [], Rectangle, () => [["North", float64_type], ["East", float64_type], ["South", float64_type], ["West", float64_type]]);
}

export class ModelArea extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Rectangle", "Polygon"];
    }
}

export function ModelArea_$reflection() {
    return union_type("StenaWeather.Domain.Models.ModelArea", [], ModelArea, () => [[["Item", Rectangle_$reflection()]], [["Item", list_type(Point_$reflection())]]]);
}

export function PolygonUtils_isPointInsidePolygon(polygon, p) {
    return (length(filter((tupledArg) => {
        const pi = tupledArg[0];
        const pj = tupledArg[1];
        if (((pi.Latitude < p.Latitude) && (pj.Latitude >= p.Latitude)) ? true : ((pj.Latitude < p.Latitude) && (pi.Latitude >= p.Latitude))) {
            return (pi.Longitude + (((p.Latitude - pi.Latitude) / (pj.Latitude - pi.Latitude)) * (pj.Longitude - pi.Longitude))) < p.Longitude;
        }
        else {
            return false;
        }
    }, pairwise(append(polygon, singleton(head(polygon)))))) % 2) === 1;
}

export function PolygonUtils_getCentroid(points) {
    const x = toArray(map((p) => p.Longitude, points));
    const y = toArray(map((p_1) => p_1.Latitude, points));
    const n = x.length | 0;
    const A = sumBy((i) => ((item(i, x) * item((i + 1) % n, y)) - (item((i + 1) % n, x) * item(i, y))), toList(rangeDouble(0, 1, n - 1)), {
        GetZero: () => 0,
        Add: (x_1, y_1) => (x_1 + y_1),
    }) / 2;
    return new Point(sumBy((i_1) => ((item(i_1, x) + item((i_1 + 1) % n, x)) * ((item(i_1, x) * item((i_1 + 1) % n, y)) - (item((i_1 + 1) % n, x) * item(i_1, y)))), toList(rangeDouble(0, 1, n - 1)), {
        GetZero: () => 0,
        Add: (x_2, y_2) => (x_2 + y_2),
    }) / (6 * A), sumBy((i_2) => ((item(i_2, y) + item((i_2 + 1) % n, y)) * ((item(i_2, x) * item((i_2 + 1) % n, y)) - (item((i_2 + 1) % n, x) * item(i_2, y)))), toList(rangeDouble(0, 1, n - 1)), {
        GetZero: () => 0,
        Add: (x_3, y_3) => (x_3 + y_3),
    }) / (6 * A));
}

export function ModelAreaModule_isPointWithin(area, p) {
    if (area.tag === 1) {
        return PolygonUtils_isPointInsidePolygon(area.fields[0], p);
    }
    else {
        const r = area.fields[0];
        if (((p.Latitude >= r.South) && (p.Latitude <= r.North)) && (p.Longitude >= r.West)) {
            return p.Longitude <= r.East;
        }
        else {
            return false;
        }
    }
}

export function ModelAreaModule_center(area) {
    if (area.tag === 1) {
        return PolygonUtils_getCentroid(area.fields[0]);
    }
    else {
        const r = area.fields[0];
        return new Point((r.East + r.West) / 2, (r.North + r.South) / 2);
    }
}

export function ModelAreaModule_resolutionInKm(sd, ma) {
    const centerPoint = ModelAreaModule_center(ma);
    const toEast = new Point(centerPoint.Longitude + sd.LonDist, centerPoint.Latitude);
    return [SpatialDistanceModule_inKilometers(centerPoint, new Point(centerPoint.Longitude, centerPoint.Latitude + sd.LatDist)), SpatialDistanceModule_inKilometers(centerPoint, toEast)];
}

export function ModelAreaModule_enclosingRectangle(ma) {
    if (ma.tag === 1) {
        const points = ma.fields[0];
        const North = max(map_1((_arg) => _arg.Latitude, points), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        const South = min(map_1((_arg_1) => _arg_1.Latitude, points), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        return new Rectangle(North, max(map_1((_arg_2) => _arg_2.Longitude, points), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), South, min(map_1((_arg_3) => _arg_3.Longitude, points), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }));
    }
    else {
        return ma.fields[0];
    }
}

export class PointBasedModelCalculation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExactPoints", "NearPoints"];
    }
}

export function PointBasedModelCalculation_$reflection() {
    return union_type("StenaWeather.Domain.Models.PointBasedModelCalculation", [], PointBasedModelCalculation, () => [[["roundDecimalDigits", int32_type]], [["precisionDistance", float64_type]]]);
}

export class ModelType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PointBased", "GridBased"];
    }
}

export function ModelType_$reflection() {
    return union_type("StenaWeather.Domain.Models.ModelType", [], ModelType, () => [[["Item", PointBasedModelCalculation_$reflection()]], []]);
}

export class Model extends Record {
    constructor(Provider, Name, SpatialResolution, TemporalResolution, Area, TemporalRange, Type, SupportedWeatherTypes, UpdateFrequency, OutdatedAlertCoefficient) {
        super();
        this.Provider = Provider;
        this.Name = Name;
        this.SpatialResolution = SpatialResolution;
        this.TemporalResolution = TemporalResolution;
        this.Area = Area;
        this.TemporalRange = TemporalRange;
        this.Type = Type;
        this.SupportedWeatherTypes = SupportedWeatherTypes;
        this.UpdateFrequency = UpdateFrequency;
        this.OutdatedAlertCoefficient = OutdatedAlertCoefficient;
    }
}

export function Model_$reflection() {
    return record_type("StenaWeather.Domain.Models.Model", [], Model, () => [["Provider", Provider_$reflection()], ["Name", string_type], ["SpatialResolution", SpatialDistance_$reflection()], ["TemporalResolution", class_type("System.TimeSpan")], ["Area", ModelArea_$reflection()], ["TemporalRange", class_type("System.TimeSpan")], ["Type", ModelType_$reflection()], ["SupportedWeatherTypes", list_type(WeatherTypeModule_Parameter_$reflection())], ["UpdateFrequency", class_type("System.TimeSpan")], ["OutdatedAlertCoefficient", float64_type]]);
}

export class ModelMetadata extends Record {
    constructor(Contact, DataSourceDescription, SourceDataType, IsRotated) {
        super();
        this.Contact = Contact;
        this.DataSourceDescription = DataSourceDescription;
        this.SourceDataType = SourceDataType;
        this.IsRotated = IsRotated;
    }
}

export function ModelMetadata_$reflection() {
    return record_type("StenaWeather.Domain.Models.ModelMetadata", [], ModelMetadata, () => [["Contact", option_type(string_type)], ["DataSourceDescription", string_type], ["SourceDataType", string_type], ["IsRotated", bool_type]]);
}

export function ModelMetadataModule_isDmiEdrModel(name) {
    switch (name) {
        case "dkss_idw_api":
        case "dkss_nsbs_api":
        case "wam_dw_api":
        case "wam_natlant_api":
        case "harmonie_dini_sf_api":
            return true;
        default:
            return false;
    }
}

export function ModelMetadataModule_isDmiStacModel(name) {
    switch (name) {
        case "dkss_idw":
        case "dkss_nsbs":
        case "wam_dw":
        case "wam_natlant":
        case "harmonie_dini_sf":
            return true;
        default:
            return false;
    }
}

export function ModelMetadataModule_get(m) {
    const matchValue = m.Provider;
    const matchValue_1 = m.Name;
    let matchResult;
    switch (matchValue.tag) {
        case 1: {
            switch (matchValue_1) {
                case "ukv_nl-uk":
                case "ukv_ie-uk": {
                    matchResult = 3;
                    break;
                }
                case "bd1_irish_sea": {
                    matchResult = 4;
                    break;
                }
                default:
                    matchResult = 5;
            }
            break;
        }
        case 2: {
            matchResult = 6;
            break;
        }
        case 3: {
            matchResult = 7;
            break;
        }
        case 4: {
            if (matchValue_1 === "nemo") {
                matchResult = 8;
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 5: {
            switch (matchValue_1) {
                case "ww3-nordbalt":
                case "ww3-innerdk": {
                    matchResult = 10;
                    break;
                }
                case "getm-nordsee":
                case "getm-denmark":
                case "getm-baltic": {
                    matchResult = 11;
                    break;
                }
                default:
                    matchResult = 12;
            }
            break;
        }
        case 6: {
            matchResult = 13;
            break;
        }
        default:
            if (ModelMetadataModule_isDmiEdrModel(m.Name)) {
                matchResult = 0;
            }
            else if (ModelMetadataModule_isDmiStacModel(m.Name)) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
    }
    switch (matchResult) {
        case 0:
            return new ModelMetadata("Phone:+4539157500 or Form:https://www.dmi.dk/kontakt/frie-data/", "Danish Meterological Institute (DMI) Open Data", "JSON", true);
        case 1:
            return new ModelMetadata("Phone:+4539157500 or Form:https://www.dmi.dk/kontakt/frie-data/", "Danish Meterological Institute (DMI) Open Data", "GRIB2", true);
        case 2:
            return new ModelMetadata("Phone:+4539157280 or Email:opr@dmi.dk", "Danish Meterological Institute (DMI)", "JSON", true);
        case 3:
            return new ModelMetadata(undefined, "UK Met Office", "GRIB2", true);
        case 4:
            return new ModelMetadata(undefined, "UK Met Office", "JSON", true);
        case 5:
            return new ModelMetadata(undefined, "UK Met Office", "NetCDF", false);
        case 6:
            return new ModelMetadata(undefined, "Baltic MFC, PU Finnish Meteorological Institute", "NetCDF", true);
        case 7:
            return new ModelMetadata(undefined, "The Norwegian Meteorological Institute", "OPeNDAP", false);
        case 8:
            return new ModelMetadata("Web: https://www.smhi.se/kontakta-smhi", "Baltic MFC, PU Swedish Meteorological and Hydrological Institute", "NetCDF", false);
        case 9:
            return new ModelMetadata("Web: https://www.smhi.se/kontakta-smhi", "Baltic MFC, PU Swedish Meteorological and Hydrological Institute", "JSON", false);
        case 10:
            return new ModelMetadata("Email: info@fcoo.dk", "Danish defense ministry (FCOO)", "NetCDF", false);
        case 11:
            return new ModelMetadata("Email: info@fcoo.dk", "Danish defense ministry (FCOO)", "GRIB2", false);
        case 12:
            return toFail(printf("Unknown model name %s"))(m.Name);
        default:
            return new ModelMetadata("Email: opendata@met.ie", "Met Éireann (Ireland\'s National Meteorological Service)", "XML", false);
    }
}

export class ModelKey extends Record {
    constructor(Provider, Name) {
        super();
        this.Provider = Provider;
        this.Name = Name;
    }
}

export function ModelKey_$reflection() {
    return record_type("StenaWeather.Domain.Models.ModelKey", [], ModelKey, () => [["Provider", Provider_$reflection()], ["Name", string_type]]);
}

export function ModelKeyModule_ofForecastSource(m) {
    return new ModelKey(m.Provider, m.Model.Name);
}

export class ModelUpdateStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpToDate", "ToBeUpdated", "Outdated"];
    }
}

export function ModelUpdateStatus_$reflection() {
    return union_type("StenaWeather.Domain.Models.ModelUpdateStatus", [], ModelUpdateStatus, () => [[], [], []]);
}

export function ModelUpdateStatusModule_getAlertFactor(now, lastUpdated, model) {
    const diff = op_Subtraction(now, lastUpdated);
    const diffAlert = fromSeconds(totalSeconds(model.UpdateFrequency) * model.OutdatedAlertCoefficient);
    if (diff <= model.UpdateFrequency) {
        return 0;
    }
    else {
        return toFloat64(ticks(diff)) / toFloat64(ticks(diffAlert));
    }
}

export function ModelUpdateStatusModule_get(now, lastUpdated, model) {
    const x = ModelUpdateStatusModule_getAlertFactor(now, lastUpdated, model);
    if (x === 0) {
        return new ModelUpdateStatus(0, []);
    }
    else if (x <= 1) {
        return new ModelUpdateStatus(1, []);
    }
    else {
        return new ModelUpdateStatus(2, []);
    }
}

export function ModelUpdateStatusModule_isUpToDate(ms) {
    return equals(ms, new ModelUpdateStatus(0, []));
}

export function ModelUpdateStatusModule_isToBeUpdated(ms) {
    return equals(ms, new ModelUpdateStatus(1, []));
}

export function ModelUpdateStatusModule_isOutdated(ms) {
    return equals(ms, new ModelUpdateStatus(2, []));
}

export function ModelModule_key(m) {
    return new ModelKey(m.Provider, m.Name);
}

export function ModelModule_isTimepointWithin(now, timePoint, model) {
    if (ModelAreaModule_isPointWithin(model.Area, timePoint.Point)) {
        return compare(timePoint.DateTime, op_Addition(now, model.TemporalRange)) <= 0;
    }
    else {
        return false;
    }
}

export function ModelModule_resolutionInKm(m) {
    return ModelAreaModule_resolutionInKm(m.SpatialResolution, m.Area);
}

export const Models_meps = new Model(new Provider(3, []), "meps", new SpatialDistance(0.04661695, 0.02245789), fromHours(1), new ModelArea(0, [new Rectangle(75.228696, 54.241262, 49.765385, -18.122414)]), fromDays(3), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(0, [])), fromHours(3), 1.5);

export const Models_amm15v2 = new Model(new Provider(1, []), "amm15v2", new SpatialDistance(0.02778, 0.02778), fromMinutes(15), new ModelArea(0, [new Rectangle(61.3, 10, 46, -16)]), fromDays(6), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(2, []), new WeatherTypeModule_Parameter(4, [])]), fromDays(1), 1.5);

export const Models_amm15s = new Model(new Provider(1, []), "amm15s", new SpatialDistance(0.05, 0.05), fromHours(1), new ModelArea(0, [new Rectangle(61.3, 10, 46, -16)]), fromDays(5), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(3, []), new WeatherTypeModule_Parameter(7, []), new WeatherTypeModule_Parameter(5, []), new WeatherTypeModule_Parameter(6, [])]), fromDays(1), 1.5);

export const Models_wam = new Model(new Provider(2, []), "wam", new SpatialDistance(0.0278, 0.0167), fromHours(1), new ModelArea(0, [new Rectangle(65.9079, 30.2077, 53.0084, 9.0139)]), fromDays(5), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(12), 1.5);

export const Models_nemo = new Model(new Provider(4, []), "nemo", new SpatialDistance(0.0278, 0.0167), fromMinutes(15), new ModelArea(0, [new Rectangle(65.890991, 30.20866, 53.008297, 9.041586)]), fromDays(5), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(12), 1.5);

export const Models_snow1g = new Model(new Provider(4, []), "snow1g", new SpatialDistance(0.033333335, 0.020952381), fromHours(1), new ModelArea(1, [ofArray(map_2((tupledArg) => (new Point(tupledArg[0], tupledArg[1])), polygonPoints))]), fromHours(54), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(8, []), new WeatherTypeModule_Parameter(9, []), new WeatherTypeModule_Parameter(10, []), new WeatherTypeModule_Parameter(11, []), new WeatherTypeModule_Parameter(12, [])]), fromHours(3), 1.5);

export const Models_ukvIeUk = new Model(new Provider(1, []), "ukv_ie-uk", new SpatialDistance(0.026963, 0.017985), fromHours(1), new ModelArea(0, [new Rectangle(55.21649, -2.658691, 51.590723, -6.70166)]), fromDays(2), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(0, []), new WeatherTypeModule_Parameter(1, [])]), fromHours(3), 1.5);

export const Models_ukvIeGlobal = new Model(new Provider(1, []), "ukv_ie-global", new SpatialDistance(0.1, 0.100153856), fromHours(1), new ModelArea(0, [new Rectangle(54.9843, -2.460938, 51.7031, -6.9609)]), fromDays(2), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(8, []), new WeatherTypeModule_Parameter(9, []), new WeatherTypeModule_Parameter(10, [])]), fromHours(6), 1.5);

export const Models_ukvNlUk = new Model(new Provider(1, []), "ukv_nl-uk", new SpatialDistance(0.026963, 0.017985), fromHours(1), new ModelArea(0, [new Rectangle(53.748711, 4.799463, 51.707487, -0.340576)]), fromDays(2), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(0, []), new WeatherTypeModule_Parameter(1, [])]), fromHours(3), 1.5);

export const Models_getmNordsee = new Model(new Provider(5, []), "getm-nordsee", new SpatialDistance(0.028, 0.017), fromHours(1), new ModelArea(0, [new Rectangle(59.525, 17.0417, 50.9083, -4.0972)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.5);

export const Models_getmDenmark = new Model(new Provider(5, []), "getm-denmark", new SpatialDistance(0.0093, 0.0055), fromHours(1), new ModelArea(0, [new Rectangle(59.525, 17.0417, 53.475, 5.9028)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.5);

export const Models_getmBaltic = new Model(new Provider(5, []), "getm-baltic", new SpatialDistance(0.0093, 0.0055), fromHours(1), new ModelArea(0, [new Rectangle(65.9083, 30.2918, 53.475, 5.9028)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.5);

export const Models_ww3Nordbalt = new Model(new Provider(5, []), "ww3-nordbalt", new SpatialDistance(0.083, 0.05), fromHours(1), new ModelArea(0, [new Rectangle(65.7917, 30.0138, 48.5417, -5.9306)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.5);

export const Models_ww3InnerDk = new Model(new Provider(5, []), "ww3-innerdk", new SpatialDistance(0.028, 0.017), fromHours(1), new ModelArea(0, [new Rectangle(56.4084, 13.3195, 53.875, 9.375)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.5);

export const Models_harmMetIr = new Model(new Provider(6, []), "harm-ir", new SpatialDistance(0.03014, 0.01799), fromHours(1), new ModelArea(1, [ofArray([new Point(-9.3, 56.2), new Point(-3.8, 55), new Point(-6.7, 50.5), new Point(-11.7, 51.6)])]), fromHours(54), new ModelType(0, [new PointBasedModelCalculation(1, [0.001])]), ofArray([new WeatherTypeModule_Parameter(9, []), new WeatherTypeModule_Parameter(8, []), new WeatherTypeModule_Parameter(10, []), new WeatherTypeModule_Parameter(11, [])]), fromHours(10), 1.5);

export const Models_dmiEdrDkssIdw = new Model(new Provider(0, []), "dkss_idw_api", new SpatialDistance(0.013888889, 0.008334021), fromHours(1), new ModelArea(0, [new Rectangle(57.596, 14.826, 53.587, 9.34)]), fromDays(6), new ModelType(0, [new PointBasedModelCalculation(1, [0.1])]), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.75);

export const Models_dmiEdrDkssNsbs = new Model(new Provider(0, []), "dkss_nsbs_api", new SpatialDistance(0.083333336, 0.050000004), fromHours(1), new ModelArea(0, [new Rectangle(65.875, 30.292, 48.525, -4.125)]), fromDays(6), new ModelType(0, [new PointBasedModelCalculation(1, [0.25])]), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.75);

export const Models_dmiEdrWamDw = new Model(new Provider(0, []), "wam_dw_api", new SpatialDistance(0.016727779, 0.010028566), fromHours(1), new ModelArea(0, [new Rectangle(60, 16, 53, 7)]), fromDays(6), new ModelType(0, [new PointBasedModelCalculation(1, [0.1])]), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.75);

export const Models_dmiEdrWamNatlant = new Model(new Provider(0, []), "wam_natlant_api", new SpatialDistance(0.25012627, 0.25026044), fromHours(1), new ModelArea(0, [new Rectangle(78, 30, 30, -69)]), fromDays(10), new ModelType(0, [new PointBasedModelCalculation(1, [0.25])]), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.75);

export const Models_dmiEdrHarmDini = new Model(new Provider(0, []), "harmonie_dini_sf_api", new SpatialDistance(0.033333335, 0.020952381), fromHours(1), new ModelArea(0, [new Rectangle(69.907191, 40.069849, 37.688397, -43.169833)]), fromDays(2), new ModelType(0, [new PointBasedModelCalculation(1, [0.25])]), ofArray([new WeatherTypeModule_Parameter(0, []), new WeatherTypeModule_Parameter(10, []), new WeatherTypeModule_Parameter(8, []), new WeatherTypeModule_Parameter(9, [])]), fromHours(3), 2.5);

export const Models_dmiStacDkssIdw = new Model(new Provider(0, []), "dkss_idw", new SpatialDistance(0.013888889, 0.008334021), fromHours(1), new ModelArea(0, [new Rectangle(57.596, 14.826, 53.587, 9.34)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.75);

export const Models_dmiStacDkssNsbs = new Model(new Provider(0, []), "dkss_nsbs", new SpatialDistance(0.083333336, 0.050000004), fromHours(1), new ModelArea(0, [new Rectangle(65.875, 30.292, 48.525, -4.125)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(2, [])), fromHours(6), 1.75);

export const Models_dmiStacWamDw = new Model(new Provider(0, []), "wam_dw", new SpatialDistance(0.016727779, 0.010028566), fromHours(1), new ModelArea(0, [new Rectangle(60, 16, 53, 7)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.75);

export const Models_dmiStacWamNatlant = new Model(new Provider(0, []), "wam_natlant", new SpatialDistance(0.25012627, 0.25026044), fromHours(1), new ModelArea(0, [new Rectangle(78, 30, 30, -69)]), fromDays(2), new ModelType(1, []), singleton_1(new WeatherTypeModule_Parameter(3, [])), fromHours(6), 1.75);

export const Models_dmiStacHarmDini = new Model(new Provider(0, []), "harmonie_dini_sf", new SpatialDistance(0.033333335, 0.020952381), fromHours(1), new ModelArea(0, [new Rectangle(69.907191, 40.069849, 37.688397, -43.169833)]), fromDays(2), new ModelType(1, []), ofArray([new WeatherTypeModule_Parameter(0, []), new WeatherTypeModule_Parameter(10, []), new WeatherTypeModule_Parameter(8, []), new WeatherTypeModule_Parameter(9, [])]), fromHours(3), 2.5);

export const Models_all = ofArray([Models_amm15s, Models_amm15v2, Models_meps, Models_nemo, Models_snow1g, Models_wam, Models_ukvIeUk, Models_ukvNlUk, Models_ukvIeGlobal, Models_ww3Nordbalt, Models_ww3InnerDk, Models_getmNordsee, Models_getmDenmark, Models_getmBaltic, Models_harmMetIr, Models_dmiStacDkssIdw, Models_dmiStacDkssNsbs, Models_dmiStacWamDw, Models_dmiStacWamNatlant, Models_dmiStacHarmDini]);

export function Models_tryGet(mk) {
    return tryFind((x) => {
        if (compare_1(x.Name, mk.Name, 3) === 0) {
            return equals(x.Provider, mk.Provider);
        }
        else {
            return false;
        }
    }, Models_all);
}

export function Models_get(mk) {
    return defaultArgWith(Models_tryGet(mk), () => {
        throw new Exception(`Cannot find ${mk} in list of registered models`);
    });
}

